import { apiProxyRequest } from "Api/apiProxyRequest";
import { GitDiff } from "Reducers/gitDiffs/types";

type GetGitDiffRequestProps = {
  projectId: string;
  right: string;
  left: string;
  glob: string;
};

export const getGitDiffRequest = ({
  projectId,
  left,
  right,
  glob
}: GetGitDiffRequestProps) =>
  apiProxyRequest<GitDiff[]>(
    `/projects/${encodeURIComponent(projectId)}/git/diffs/${encodeURIComponent(left)}/${encodeURIComponent(right)}?path=${encodeURIComponent(glob)}`,
    "GET"
  );
